import { ICustomizerState } from "./customizer/customizerReducer";
import { IMessagesState } from "./messages/messages.types";
import { initialMessagesState } from "./messages/messagesState";
import { IStudentState } from "./student/student.types";
// import { IAutomobilePolicyRiskLocationState, defaultAutomobilePolicyRiskLocationState } from "./automobilePolicyRiskLocation/automobilePolicyRiskLocation.types";
import { defaultCommonState, ICommonState } from "./common/common.types";

import { IUsersState } from "./UserProfileList/userProfile.types";
import { initialUserProfileState } from "./UserProfileList/userprofileState";
import { IChatbotState, initialChatbotState } from "./chatbot/chatbot.types";

import {
	IAcitivtyState,
	initialAcitvityState,
} from "./activity/activity.types";
import { ILeadsState, initialLeadState } from "./leads/leads.types";
import { defaultOpportunityState } from "./opportunites/deafaultState";
import { IOpportunityState } from "./opportunites/opportunites.types";
import {
	initialSecurityState,
	ISecurityState,
} from "./security/security.types";
import { defaultStudentState } from "./student/studentState";
import {
	initialTemplateState,
	ITemplateState,
} from "./templates/templates.types";

import {
	defaultUserDocument,
	defaultUserDocumentState,
} from "./userDocument/userDocument.state";
import {
	IUserDocument,
	IUserDocumentState,
} from "./userDocument/userDocument.types";
import { IUserBranchState } from "./userBranch/userBranch.types";
import { defaultUserBranchState } from "./userBranch/userBranch.state";
import {
	IEnvConfigState,
	initialEnvConfigState,
} from "./envConfig/envConfig.types";
import {
	ICompanyInformationState,
	initialCompanyInformation,
} from "./CompanyInformation/companyInformation.types";
import { IBookingState, initialBookingState } from "./booking/booking.types";
import {
	ICategoryState,
	initialCategoryState,
} from "./category/category.types";
import {
	ICategoryTypeState,
	initialCategoryTypeState,
} from "./categoryType/categoryType.types";
import { IFoodState, initialFoodState } from "./food/food.types";
// import {
// 	IMarketCampaignState,
// 	initialMarketCampaignState,
// } from "./marketCampaign/marketCampaign.types";
import { IGoogleReviewState } from "./Review/review.types";
import { defaultGoogleReviewState } from "./Review/review.state";
import { ICompanyOutletState } from "./companyOutlet/companyOutlet.types";
import { initialCompanyOutletState } from "./companyOutlet/defaultState";
import { IEventsState, initialEventsState } from "./events/events.types";
import { IAuctionState, initialAuctionState } from "./auction/auction.types";
import { IPartnersState } from "./partners/Partners.types";
import { IOnlineDsaLimitState, } from "./OnlineDsaLimit";
import { OnlineDsaLimitInitialState } from "./OnlineDsaLimit/OnlineDsaLimit.state";
import { ILeadsfromWebsiteState, initialLeadfromWebsiteState } from "./leadsfromwebsite/leadsfromwebsite.types";
import { initialPartnersState } from "./partners/Partners.state";
import { ICrossroadsLeadsState } from "./CrossroadsLeads/CrossroadsLeads.types";
import { InitialCrossroadsLeadsReduxState, InitialCrossroadsLeadsState } from "./CrossroadsLeads/CrossroadsLeads.state";
import { ICallingState } from "./calling/calling.types";
import { InitialCallingState } from "./calling/calling.states"
import { initialWhatsAppTemplateState } from "./whatsappTemplate/defaultState";
import { IWhatsAppTemplateState } from "./whatsappTemplate/whatsappTemplate.types";
import { initialMarketingCampaignState, IMarketingCampaignState } from "./market-Campaign/marketCampaign.types"
import { initialActionItemState } from "./actionItems/actionItem.state";
import { IActionItemsState } from "./actionItems";

import { IOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";
import { initialOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";
import { IQuickReplyTemplateState } from "./quickReplyTemplates/quickReplyTemplate.types";
import { initialQuickReplyTemplateState } from "./quickReplyTemplates/defaultState";
import { ICampaign, ICampaignState } from "./campaign/campaign.types";
import { initialCampaignState } from "./campaign/campaign.states";
import { initialApiKeyState } from "./apikey/apikey.states";
import { IApiKeyState } from "./apikey/apikey.types";
import { IRsaPackageState } from "./rsaPackages/rsaPackages.types"
import { initialRsaPackageState } from "./rsaPackages/rsaPackages.states"
import { IPromocodeState } from "./promocode/promocode.types";
import { initialPromocodeState } from "./promocode/promocode.state";
import { IDispositionState } from "./disposition/disposition.types";
import { initialDispositionState } from "./disposition/disposition.state";
import { IMarketCampaignRuleTemplateState, IMarketCampaignState, initialMarketCampaignState } from "./marketCampaign/marketCampaign.types";
import { initialMarketCampaignRuleTemplateState } from "./marketCampaign/marketCampaign.state";
import { ICampaignReportsState } from "./CrossroadsLeads/CampaignReports/CampaignReports.types";
import { InitialCampaignReportsReduxState } from "./CrossroadsLeads/CampaignReports/CampaignReports.state";
import { iCallCampaignState } from "./CallCampaign";
import { defaultCallCampaignState } from "./CallCampaign/defaultState";
import { IUpsellLeadsState, initialUpsellLeadsState } from "./upsellLead";
import { IPAInsuranceState, initialPAInsuranceState } from "./paInsurance";
import { IManageMembershipState, initialManageMembershipState } from "./manageMembership";
import { IMechanicListState, initialMechanicListState } from "./mechanicList";
import { IComplaintsState, initialComplaintsState } from "./complaints";
import { ILawyeredState } from "./lawyered/lawyered.types";
import { initialLawyeredState } from "./lawyered/lawyered.state";

export interface IDropdownListType {
	key: string;
	text: string;
	value: string;
}

export interface IStoreState {
	customizerReducer: ICustomizerState;
	student: IStudentState;
	message: IMessagesState;
	acitivty: IAcitivtyState;
	security: ISecurityState;

	userprofile: IUsersState;
	common: ICommonState;
	templates: ITemplateState;

	companyInformation: ICompanyInformationState;
	onlineDsaLimit: IOnlineDsaLimitState;
	opportunites: IOpportunityState;
	leads: ILeadsState;
	leadsfromwebsite: ILeadsfromWebsiteState;
	userDocument: IUserDocumentState;
	userBranch: IUserBranchState;
	envConfig: IEnvConfigState;
	booking: IBookingState;
	category: ICategoryState;
	companyOutlet: ICompanyOutletState;
	categoryType: ICategoryTypeState;
	food: IFoodState;
	marketCampaign: IMarketCampaignState; //redux -> marketCampaign (new)
	review: IGoogleReviewState;
	events: IEventsState;
	auction: IAuctionState;
	partners: IPartnersState;
	crossroadsLeads: ICrossroadsLeadsState;
	calling: ICallingState;
	whatsappTemplate: IWhatsAppTemplateState;
	marketingCampaign: IMarketingCampaignState //redux -> market-Campaign (old)
	chatbot: IChatbotState;
	actionItems: IActionItemsState;
	orgEnvConfig: IOrgEnvConfigState;
	quickReplyTemplate: IQuickReplyTemplateState;
	campaign: ICampaignState
	complaints: IComplaintsState;
	apikey: IApiKeyState;
	rsaPackage: IRsaPackageState;
	promocode: IPromocodeState;
	disposition: IDispositionState;
	campaignReports: ICampaignReportsState;
	callCampaign: iCallCampaignState;
	upsellLeads: IUpsellLeadsState;
	paInsurance: IPAInsuranceState;
	manageMembership: IManageMembershipState;
	mechanicList: IMechanicListState;
	lawyered: ILawyeredState;
}

export const initialStoreState: IStoreState = {
	//if you want to change the theme of framework, first go to themevariable.ts file, and set your theme there, then come in this file and simply put your theme in activveTheme
	customizerReducer: {
		activeDir: "ltr",
		activeNavbarBg: "#0b70fb", // This can be any color,
		activeSidebarBg: "#ffffff", // This can be any color
		activeMode: "light", // This can be light or dark
		activeTheme: "FEE_MANAGEMENT_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
		SidebarWidth: 100,
		sidebarOpen: true,
	},

	student: defaultStudentState,
	message: initialMessagesState,
	templates: initialTemplateState,
	whatsappTemplate: initialWhatsAppTemplateState,
	security: initialSecurityState,

	common: defaultCommonState,
	acitivty: initialAcitvityState,

	userprofile: initialUserProfileState,

	companyInformation: initialCompanyInformation,

	opportunites: defaultOpportunityState,
	leads: initialLeadState,
	leadsfromwebsite: initialLeadfromWebsiteState,
	userDocument: defaultUserDocumentState,
	userBranch: defaultUserBranchState,
	companyOutlet: initialCompanyOutletState,
	envConfig: initialEnvConfigState,
	booking: initialBookingState,
	category: initialCategoryState,
	categoryType: initialCategoryTypeState,
	food: initialFoodState,
	marketCampaign: initialMarketCampaignState, //redux -> marketCampaign (new)
	review: defaultGoogleReviewState,
	events: initialEventsState,
	auction: initialAuctionState,
	partners: initialPartnersState,
	onlineDsaLimit: OnlineDsaLimitInitialState,
	crossroadsLeads: InitialCrossroadsLeadsReduxState,
	calling: InitialCallingState,
	marketingCampaign: initialMarketingCampaignState, //redux -> market-Campaign (old)
	chatbot: initialChatbotState,
	actionItems: initialActionItemState,
	orgEnvConfig: initialOrgEnvConfigState,
	quickReplyTemplate: initialQuickReplyTemplateState,
	campaign: initialCampaignState,
	complaints: initialComplaintsState,
	apikey: initialApiKeyState,
	rsaPackage: initialRsaPackageState,
	promocode: initialPromocodeState,
	disposition: initialDispositionState,
	campaignReports: InitialCampaignReportsReduxState,
	callCampaign: defaultCallCampaignState,
	upsellLeads: initialUpsellLeadsState,
	paInsurance: initialPAInsuranceState,
	manageMembership: initialManageMembershipState,
	mechanicList: initialMechanicListState,
	lawyered: initialLawyeredState,
};
